import React from "react";

function InputForm({ placeholder, name, value, onChange, type, error, disabled }) {
  return (
    <div className="form-group mb-0">
      <label className="editLabelForm text-bold my-1">{placeholder}</label>
      <input
        className={`form-control ${error ? "border border-danger" : "editInputForm"} ${error && "is-invalid"}`}
        style={error && {borderColor: "red!important"}}
        type={type}
        placeholder={placeholder}
        name={name}
        value={value || ""}
        disabled={disabled || false}
        onChange={onChange}
      />
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
}

export default InputForm;
